export const LS_KEY = 'aolrv'
export const LS_VERSION = 1
export const MAX_LS_ITEMS = 10

export const INITIAL_STATE = {
  version: LS_VERSION,
  items: []
}
export const TYPES = {
  ARTICLE: 'article',
  RECIPE: 'recipe'
}

export const XHR_URL = '/nex/modules/recently_viewed/v1/?m_mode=json&isXHR=true'

export const CLASSNAMES = {
  RV: 'm-rv',
  RV_INNER: 'm-rv__inner'
}
